import React, { useState, useEffect } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled from '@emotion/styled';

import {
  Badge,
  Button,
  ButtonGroup,
  IconButton,

} from "@mui/material";

import tableIcons from "../tableFormatting/tableIcons";
// import CustomAvatar from '../TableComponents/CustomAvatar'
// import { ReactComponent as RedArrow } from '../../assets/icons/High.svg'
// import { ReactComponent as YellowArrow } from '../../assets/icons/Medium.svg'
// import { ReactComponent as BlueArrow } from '../../assets/icons/Low.svg'

const TaskInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 15px;
  min-height: 106px;
  border-radius: 5px;
  max-width: 311px;
  /* background: ${({ isDragging }) =>
    isDragging ? 'rgba(255, 59, 59, 0.15)' : 'white'}; */
  background: white;
  margin-top: 15px;

  .secondary-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 12px;
    font-weight: 400px;
    color: #7d7d7d;
  }
  /* .priority{ */
  /* margin-right: 12px; */
  /* align-self: center;
    svg{
      width: 12px !important;
      height: 12px !important;
      margin-right: 12px; */
  /* margin-top: 2px; */
  /* } */
  /* } */
`;

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    opacity: "0.6"
  },
}));


const TaskCard = ({ item, index }) => {

  const [liked, setLiked] = useState(false);
  const [likedValue, setLikedValue] = useState(2);

  const [commented, setCommented] = useState(false);
  const [commentedValue, setCommentedValue] = useState(2);
  
  useEffect(() => {
    if (liked == true) {
      setLikedValue(likedValue + 1);
    }
    if (liked == false) {
      setLikedValue(likedValue - 1);
    }
  }, [liked])
  
  useEffect(() => {
    if (commented == true) {
      setCommentedValue(commentedValue + 1);
    }
    if (liked == false) {
      setCommentedValue(commentedValue - 1);
    }
  }, [liked])


  return (
    <Draggable key={index} draggableId={item.id} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <TaskInformation>
            <p>{item.Task}</p>
            <div className="secondary-details">
              <p>

            <p style={{ color: item.color }}>Priority: {item.Priority}</p>

                <span>
                  Submitted:
                  {" " + new Date(item.Due_Date).toLocaleDateString('en-us', {
                    month: 'short',
                    day: '2-digit',
                  })}
                </span>

              </p>
              <ButtonGroup>
              <IconButton
                  // style={{ position: "absolute", right: "5vw", marginTop: "20px" }}
                 onClick={() => setLiked(liked === false ? true : false)} 
                  
                  >
                      <StyledBadge color={liked === false ? "primary" : "success"} anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={item.likes + likedValue}>
                      {/* <StyledBadge color={liked === false ? "primary" : "success"} anchorOrigin={{ vertical: "top", horizontal: "left" }} > */}
                    <tableIcons.ThumbUpIconNC color={liked === false ? "" : "success"}/>
                       </StyledBadge>
                  </IconButton>
              <IconButton
                  // style={{ position: "absolute", right: "5vw", marginTop: "20px" }}
                  onClick={() => setCommented(commented === false ? true : false)} 
                  
                  >
                      <StyledBadge color={commented === false ? "primary" : "success"} anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={item.comments + commentedValue}>
                     
                    <tableIcons.CommentIcon color={commented === false ? "" : "success"}/>
                       </StyledBadge>
                  </IconButton>
                  </ButtonGroup>
                  {/* dklkmlknuiybu
                  <Button>sfsfsfsf</Button> */}
            </div>

          </TaskInformation>

        </div>
      )}
    </Draggable>
  );
};

export default TaskCard;

// <span className="priority">
// {item.Priority === 'High' ? (<RedArrow />) : item.Priority === 'Medium' ? (<YellowArrow />) : (<BlueArrow />)}
// </span>
// <div><CustomAvatar name={item.Assignee} isTable={false} size={16} /></div>
